import i18next from 'i18next';
import {type Record} from 'immutable';

import {type RootState} from 'web-app/react/redux/root-state';
import {type InferRecord} from 'web-app/util/immutable';

import EntityFactory from '../factory/famly-app';
import Product from '../products/model';

type IProductRecord = InferRecord<InstanceType<typeof Product['record']>>;

export default EntityFactory.createEntity<IProductRecord, Record.Factory<IProductRecord>, RootState>({
    domain: 'ENTITIES/PRODUCTS',
    entityName: i18next.t('entities.names.product'),
    model: Product,
    apiDescription: {
        fetchAll: {
            url: 'v2/products',
            requestPayload: payload => ({
                institutionId: payload.institutionId,
                validOn: payload.validOn,
                validTo: payload.validTo,
                includeDiscontinued: payload.includeDiscontinued,
                ageGroupIds: payload.ageGroupIds,
                behaviors: 1,
            }),
            locateResponse: response => response.products,
        },
    },
});
